import React, { useEffect, useState } from "react";
import PublishAssessBox from "./PublishAssessBox";
import axios from "../../../../../axios";

const PublishAccessBoxProps = ({ filter, setFilter }) => {
  const [publishedAssesssmentList, setPublishedAssessmentList] = useState([]);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [inDeactiveProcess, setDeactiveProcess] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);

  function convertToISO(dateString) {
    const date = new Date(dateString);
    const isoDate = date.toISOString();
    return isoDate;
  }

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  const getPublishedAssessment = async () => {
    try {
      let res = await axios.get(
        `/api/v1/assessment/filterByTeacherId/${teacher_id}/published?sortBy=-1&_page=1&_limit=100&academicSessionId=${academicSessionId}&timetableSessionId=${timeTableSessionId}` +
          `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
          `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
          `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
          `&${filter?.date && `date=${convertToISO(filter?.date)}`}` +
          `&${filter?.time && `time=${filter?.time}`}` +
          `&${
            filter?.subjectId?.length !== 0 && `subjectId=${filter?.subjectId}`
          }`,
      );
      res &&
        localStorage.setItem(
          "PublishedAssessmentData",
          JSON.stringify(res.data.data),
        );
      setPublishedAssessmentList(res.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPublishedAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, inDeactiveProcess]);

  // const handelInfiniteScroll = async () => {
  //   try {
  //     if (
  //       document.getElementById("total-assessment-library-question")
  //         .clientHeight +
  //         document.getElementById("total-assessment-library-question")
  //           .scrollTop +
  //         1 >=
  //       document.getElementById("total-assessment-library-question")
  //         .scrollHeight
  //     ) {
  //       setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   const element = document.getElementById(
  //     "total-assessment-library-question"
  //   );
  //   if (element) {
  //     element.addEventListener("scroll", handelInfiniteScroll);
  //   }

  //   return () => {
  //     if (element) {
  //       element.removeEventListener("scroll", handelInfiniteScroll);
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
      {publishedAssesssmentList.length > 0 ? (
        <div className="container">
          <div className="row">
            {publishedAssesssmentList.map((assessment, index) => (
              <div key={index} className="col-md-3 d-flex mb-3">
                <PublishAssessBox
                  assessment={assessment}
                  setDeactiveProcess={setDeactiveProcess}
                  getPublishedAssessment={getPublishedAssessment}
                />
              </div>
            ))}
          </div>
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <div className="d-flex justify-content-center align-items-center w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            🧾 Assessment Not Found
          </span>
        </div>
      )}
    </>
  );
};

export default PublishAccessBoxProps;
